export default "__VITE_PUBLIC_ASSET__7a6b2cab__"